import { Component } from '@angular/core';

import {
    Animations,
    BackendOberflaecheService,
    BausteinBeitrag,
    ModalService,
    RateService,
    StandardBeitragComponent,
    TarifierungResponse,
} from '@vhv/tarifrechner-common';

@Component({
    selector: 'cyber-bausteine',
    animations: [Animations.slideInDownAnimation],
    templateUrl: 'cyber-bausteine.component.html',
})
export class CyberBausteineComponent extends StandardBeitragComponent {

    bausteinBeitraege: Map<string, BausteinBeitrag> = null;

    constructor(
        private rateService: RateService,
        private _inputBackendOberflaecheService: BackendOberflaecheService,
        private modalService: ModalService,
    ) {
        super(
        );

    }

    initialiseSeite() {
        super.initialiseSeite();

        this.rateService.calculateBeitrag();

        if (!this.currentSeite) {
            return;
        }

        for (let element of this.currentSeite.elemente) {
            this.form.get(element.attribut.name).valueChanges.subscribe(value => this.onChange(value));
        }

        const promise: Promise<TarifierungResponse> = this.rateService.getBausteinBeitrag('');
        if (promise) {
            promise.then(value => {
                this.bausteinBeitraege = value.beitraegeFuerBausteine;
            })
                .catch(error => {
                    this.error(error);
                });
        }
    }

    protected onChange(value: string): void {
        super.onChange(value);

        this.rateService.calculateBeitrag();
    }

    onSubmit() {
        super.onSubmit();
    }

    showBausteinMehrInfo(bausteinElementName: string) {
        const bausteinElement = this._inputBackendOberflaecheService.getElementByName(bausteinElementName);

        if (!bausteinElement) {
            console.warn('Baustein [' + bausteinElementName + '] nicht verfügbar');
            return;
        }

        const bausteinMehrInfoElementName = bausteinElementName + 'MehrInfo';
        const bausteinMehrInfoText = this._inputBackendOberflaecheService.getStatischenText(bausteinMehrInfoElementName);

        if (!bausteinMehrInfoText) {
            console.warn('Baustein-Mehr-Info-Text [' + bausteinMehrInfoElementName + '] nicht verfügbar');
            return;
        }

        this.modalService.showDialog(
            bausteinElement.attribut.label,
            bausteinMehrInfoText
        );
    }

}
